export default {"src":"/_next/static/media/dots-slateus.ba70b506.svg","height":100,"width":100};